<template>
  <v-app class="bg-color">
    <v-main>
      <v-container fluid grid-list-xs pt-5>
        <v-layout row wrap justify-center align-center>
          <v-flex xs11 lg11>
            <h2>
              <v-icon color="#077893" @click="Fn_BackIndex" size="38"
                >mdi-chevron-left</v-icon
              >{{ $t("policyForm.crpolicy") }}
            </h2>
          </v-flex>
        </v-layout>

        <v-layout row wrap justify-center align-center pt-5>
          <v-flex xs11 lg11>
            <v-form ref="form" v-model="valid" lazy-validation>
              <v-card class="rounded-lg">
                <v-card-title primary-title>
                  {{ $t("policyForm.policyin") }}
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                  <v-layout row wrap justify-center align-center pt-2>
                    <v-flex xs11 md11 lg11 text-left>
                      <b class="red--text mr-1">*</b>
                      <b>{{ $t("policyForm.psps") }}</b> <br />
                      <v-text-field
                        outlined
                        dense
                        color="info"
                        v-model="Title"
                        :label="$t('consentlist.topic')"
                        :rules="[(v) => !!v || $t('policyForm.psps')]"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap justify-center align-center pt-2>
                    <v-flex xs11 md11 lg11 pb-4>
                      <b class="red--text mr-1">*</b>
                      <b>{{ $t("policyForm.detail") }}</b>
                      <vue-editor
                        v-model="Content"
                        :editorToolbar="DefaultToolbar"
                        :rules="[(v) => !!v || $t('policyForm.pspd')]"
                      ></vue-editor>
                    </v-flex>
                  </v-layout>
                </v-card-text>
                <v-card-actions>
                  <v-layout row wrap justify-center align-center pb-5 mr-5>
                    <v-flex xs3 md3 lg3>
                      <v-btn
                        :loading="loading"
                        block
                        dark
                        color="#077893"
                        @click="Fn_CreatePolicy"
                        >{{ $t("policy.text10") }}</v-btn
                      >
                    </v-flex>
                  </v-layout>
                </v-card-actions>
              </v-card>
            </v-form>
          </v-flex>
        </v-layout>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import authorization from "@/functions/authorization.js";
import Swal2 from "sweetalert2/dist/sweetalert2.js";
import "sweetalert2/src/sweetalert2.scss";
import { VueEditor } from "vue2-editor";
import { mapGetters } from "vuex";

const Toast = Swal2.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});
export default {
  components: { VueEditor },
  data: function () {
    return {
      valid: true,
      ItemPolicy: [],
      Title: "",
      Content: "",
      DefaultToolbar: [
        [{ header: [false, 1, 2, 3, 4, 5, 6] }],
        ["bold", "italic", "underline", "strike"],
        [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
        [
          { align: "" },
          { align: "center" },
          { align: "right" },
          { align: "justify" },
        ],
        [{ color: [] }, { size: 56 }, { background: [] }],
      ],
      loading: false,
    };
  },
  computed: {
    ...mapGetters(["Business"]),

    _BusinessName: {
      get() {
        return this.Business.BusinessNameTH || "-";
      },
    },
  },
  mounted() {},
  methods: {
    async Fn_CreatePolicy() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        var payload = {
          BusinessId: this.$cookies.get("BusinessId"),
          AccessToken: this.$cookies.get("OneAccessToken"),
          AccountId: this.$cookies.get("OneAccountId"),
          Title: this.Title,
          Details: this.Content,
        };
        var Headers = {
          AccountId: this.$cookies.get("OneAccountId"),
        };
        var dataEncode = await authorization.encodeDataNew(payload);
        var auth = await authorization.encodeDataNew(Headers);
        var headers = { Authorization: "Bearer " + auth };
        this.axios
          .post(
            process.env.VUE_APP_API_FACTORING_SERVICE +
              "policy/InsertDetailPolicy",
            { Data: dataEncode },
            { headers }
          )
          .then((response) => {
            this.loading = false;

            if (response.data.Status === "OK") {
              this.ItemPolicy = response.data.Message;
              Toast.fire({
                icon: "success",
                title: this.$i18n.t("policy.text8"),
              });
              this.Fn_BackIndex();
            } else {
              Toast.fire({
                icon: "error",
                title: response.data.ErrorMessage,
              });
            }
          })
          .catch((error) => {
            if (error.response) {
              Toast.fire({
                icon: "error",
                title: error.response.data.ErrorMessage,
              });
            } else if (error.request) {
              Toast.fire({
                icon: "error",
                title: error.request,
              });
            } else {
              Toast.fire({
                icon: "error",
                title: error.message || error,
              });
            }
          });
      }
    },
    Fn_BackIndex() {
      this.$router.push("/policy-index");
    },
  },
};
</script>

<style>
td {
  border-style: hidden !important;
}
</style>

<style scoped>
.bg-color {
  background-color: #ddf7ff;
}
</style>
